<style>

.dialog{
	z-index: 1000;
	position: fixed;
	top: 30%;
	/* bottom: 10%; */
	left: 50%;
	width: 330px;
  height: 300px;
	margin-left: -165px;
  border: 1px white solid;
	background-color: #999;
  color: black;
	/* padding: 20px 0 0 0; */
	box-shadow: 0 10px 10px rgba(0,0,0,0.5);
  font-size: 24px;
  text-align: center;
}

h3{
  color: white;
  margin: 8px 0;
}
.image{
  /* text-align: center; */
  /* position: relative; */
}

.done{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
	z-index: 1000;
}
.overlay{
  background-color: black;
}
</style>


{#if show}

<div class="overlay" on:click="{ () => {dispatch('close')} }"></div>

<div class="dialog">
  <div class="image">
    <Cropper {image} bind:crop bind:zoom aspect="{1}" on:cropcomplete={e => console.log(e.detail)}></Cropper>
  </div>
</div>

<div class="done">
  <button on:click="{ () => {dispatch('close')} }">Done</button>
</div>

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

// https://github.com/ValentinH/svelte-easy-crop
import Cropper from "svelte-easy-crop";
import EmptyImage from "../helpers/EmptyImage.js";

export let show = false;
export let image = EmptyImage.image();

let crop = { x: 0, y: 0 };
let zoom = 1;

</script>